import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import "./Visit_History_Modal.css";
import { Table } from "react-bootstrap";
import { getData } from "../../../../utils/api";
import Visit_Status_History_Modal from "../visit_status_history_modal/Visit_Status_History_Modal";

const Visit_History_Modal = ({ show, onHide, setErr, id }) => {
  const [showHistory, setShowHistory] = useState(false);
  const [HistoryData, setHistoryData] = useState([]);

  const [data, setData] = useState([]);


  const getAllData = async () => {
    {
      const res = await getData(
        `/complaint-management/preventive-maintainance/visit-history/${id}`
      );
      setData(res?.data);
    }
  };

  useEffect(() => {
    getAllData();
  }, [id]);
  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Visit All Month History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Month</th>
                  <th>Visit Date</th>
                  <th>Status</th>
                  <th>History</th>
                </tr>
              </thead>

              <tbody>
                {data?.map((d, index) => (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>
                      {d?.visit_month
                        ? new Date(d.visit_month).toLocaleDateString("en-US", {
                            month: "short",
                            year: "numeric",
                          })
                        : ""}
                    </td>

                    <td>
                      {d?.visit_date
                        ? new Date(d.visit_date).toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })
                        : "Not Visit"}
                    </td>

                    <td>{d?.visit_status?.name}</td>
                    <td>
                      <button
                        className="view_btn"
                        onClick={() => {
                          setShowHistory(true);
                          setHistoryData(d?.preventive_maintainance_histories);
                        }}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="btn_holder"></div>
      </Modal.Body>
      <Visit_Status_History_Modal
        show={showHistory}
        HistoryData={HistoryData}
        onHide={() => {
          setShowHistory(false);
        }}
      />
    </Modal>
  );
};

export default Visit_History_Modal;
